import React, { useState, useContext } from "react";
import { useIntl } from "react-intl";
// UI
import MaterialTable from "@material-table/core";

// Table Params
import { getColumns, OPTIONS, getLocalization } from "./UserGroupParams";
import { tableIcons } from "../../TableIcons";
import apiRequest from "../../../services/apiRequest";
import TableStyle from "../../../components/TableStyle";
import Button from "../../Button";
import { NotificationsContext } from "../../Notifications";

export default function UserGroupTable({ users, selectedGroup, refresh }) {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const [selectedUsers, setSelectedUsers] = useState([]);

  function onSelectionChange(rows) {
    const user_ids = rows.map((user) => user.id);
    setSelectedUsers(user_ids);
  }

  async function addUsers() {
    await apiRequest
      .post(`/groups/users/${selectedGroup}`, selectedUsers)
      .catch(() => {
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      });
    refresh();
  }

  return (
    <>
      <TableStyle>
        <MaterialTable
          columns={getColumns(intl)}
          data={users}
          icons={tableIcons}
          options={OPTIONS}
          localization={getLocalization(intl)}
          onSelectionChange={onSelectionChange}
          isLoading={users === undefined}
        />
      </TableStyle>
      <Button
        onClick={() => addUsers()}
        styleType="empty"
        className="text-xs text-black-500 hover:text-am-500 mt-10"
      >
        Aggiungi
      </Button>
    </>
  );
}
